export const HANDOFF_READY_MESSAGE = 'nova:handoff:ready';
export const HANDOFF_TOKEN_MESSAGE = 'nova:handoff:token';
// Value of the ?handoff query param that tells the destination to wait for a token from its opener.
export const OPENER_HANDOFF_QUERY_VALUE = 'opener';

const RECEIVER_TIMEOUT_MS = 5000;

interface ReceiveHandoffFromOpenerParams {
  openerOrigin: string | undefined;
  timeoutMs?: number;
}

/**
 * Asks the window that opened this one for an access token and waits for it. Only the origin of
 * `openerOrigin` is used. Resolves null without an opener, without an opener origin, or when no
 * token arrives in time.
 */
export function receiveHandoffFromOpener({
  openerOrigin,
  timeoutMs = RECEIVER_TIMEOUT_MS
}: ReceiveHandoffFromOpenerParams): Promise<string | null> {
  const opener = window.opener as Window | null;
  if (!opener || !openerOrigin) {
    return Promise.resolve(null);
  }

  const expectedOrigin = new URL(openerOrigin).origin;

  return new Promise(resolve => {
    function finish(token: string | null) {
      clearTimeout(timeoutId);
      window.removeEventListener('message', onMessage);
      resolve(token);
    }

    function onMessage(event: MessageEvent) {
      if (
        event.source !== opener ||
        event.origin !== expectedOrigin ||
        event.data?.type !== HANDOFF_TOKEN_MESSAGE
      ) {
        return;
      }
      const { token } = event.data;
      if (typeof token !== 'string' || token.length === 0) {
        return;
      }
      finish(token);
    }

    const timeoutId = setTimeout(() => finish(null), timeoutMs);
    window.addEventListener('message', onMessage);
    opener.postMessage({ type: HANDOFF_READY_MESSAGE }, expectedOrigin);
  });
}
